export default function initProcessing() {
    const dvlaProcessing = document.querySelector('.dvla-processing');
    const backButton = document.querySelector('.govuk-back-link');
    const button = document.querySelector('#processingForm .govuk-button');

    if (button && dvlaProcessing) {
        button.onclick = () => {
            dvlaProcessing.classList.add('dvla-processing-processing');
            if (backButton) {
                backButton.style.display = 'none';
            }
        };
    }
}
